import { IErrorRes } from '@remote/type'
import { IHeziCommonRes } from '@remote/type/hezi'

export function adapterGetNfosHander<T = API_NFO.GetNFOListResponse> (conifg: { url: string }, res: [IErrorRes, IHeziCommonRes<T>]) {
  const heziApiGetNfosPath = 'api-hezi.xunlei.com/device/v1/nfos'
  const heziApiGETNfosDramas = 'api-hezi.xunlei.com/device/v1/nfos/dramas'

  const isHit = conifg.url.includes(heziApiGetNfosPath)
  if (!isHit) return Promise.resolve(res)

  const [, data] = res
  const isHitGetDeamas = conifg.url.includes(heziApiGETNfosDramas)
  console.log('adapterGetNfosHander', data)
  if (data?.ret !== 0 || !data?.data) return Promise.resolve(res)
  if (isHitGetDeamas) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return Promise.resolve(data?.data?.nfos?.map(item => ({ ...item.scrape_result, ...item.video_info })))
  } else {
    return Promise.resolve({
      data: {
        ...data.data,
        'runtime': {
          'state': 'finished',
          'stage': 'scraping',
          'dir_total_count': 26,
          'video_total_count': 136,
          'dir_done_count': 742,
          'video_done_count': 742,
          'start_time': '2022/12/05 14:23:08',
          'end_time': '2022/12/05 14:23:19',
          'err_details': null,
        },
      },
    })
  }
}

export function adapterGetFileInfoHander<T = any> (conifg: { url: string }, res: [IErrorRes, IHeziCommonRes<T>]) {
  const heziApiGetFilesPathV1 = 'api-hezi.xunlei.com/drive/v2/files'
  const heziApiGetFilesPathV2 = 'api-hezi.xunlei.com/drive/v1/files'
  const isHit = conifg.url.includes(heziApiGetFilesPathV1) || conifg.url.includes(heziApiGetFilesPathV2)
  if (!isHit) return Promise.resolve(res)
  const [, data] = res
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const result = data?.data && data?.code === 200 ? [null, { ...data?.data, web_content_link: decodeURIComponent(data?.data?.web_content_link)}] : [data]
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  console.log('adapterGetFileInfoHander', conifg.params, res)
  return Promise.resolve(result)
}